<template>
  <div class="header">
    <div>
      <h1>{{ title }}</h1>
    </div>
    <div class="d-none d-sm-none d-md-block d-lg-block">
      <v-text-field
        v-if="showSearch"
        rounded
        filled
        append-icon="fas fa-search"
        :placeholder="searchTitle"
        v-model="setSearchTerm"
        hide-details
      />
    </div>
    <div class="option">
      <v-btn v-if="showNewButton" @click="$emit('add')" rounded color="primary">
        <v-icon right dark class="mr-2"> fas fa-plus </v-icon> Agregar
      </v-btn>

      <v-btn
        v-if="showFilters"
        class="pa-5 ml-5"
        @click="$emit('filters')"
        rounded
        color="primary"
      >
        <v-icon right dark class="mr-2"> fas fa-filter </v-icon> Filtros
      </v-btn>

      <v-btn
        v-if="showReports"
        class="pa-5 ml-5"
        @click="$emit('reports')"
        rounded
        color="primary"
      >
        <v-icon right dark class="mr-2"> fas fa-file-excel </v-icon> Reportes
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "search",
  props: [
    "title",
    "showSearch",
    "showNewButton",
    "loading",
    "searchTitle",
    "showFilters",
    "showReports",
  ],
  computed: {
    ...mapState(["search", "searchTerm", "searchLabel"]),
    setSearchTerm: {
      get() {
        return this.searchTerm;
      },
      set(e) {
        this.updateSearchTerm(e);
      },
    },
  },

  methods: {
    ...mapActions(["updateSearchTerm"]),
  },
};
</script>

<style lang="scss" >
.header {
  display: grid;
  justify-content: center;
  grid-template-columns: 30% 35% 35%;
  align-items: center;
  margin-top: 30px;
}

h1 {
  font-size: 28px;
  line-height: 28px;
}

.option {
  display: flex;
  justify-content: flex-end;
  margin-right: 2vw;
}

@media screen and (max-width: 992px) {
  .header {
    padding: 0 5px 0 5px;
    // grid-template-columns: 100% 100% 100%;
    display: block !important;
    h1 {
      font-size: 25px;
    }

    .option {
      margin-right: 0 !important;
      padding-right: 0 !important;
    }
  }
}
</style>